/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Loader from "../../../component/loader";
import constants from "../../../helper/constants";
import BusApiCall from "../../../helper/axios";
import Button from "../../../component/button";
import Confirmation from "../provider/confirmation";
import { withTranslation } from "react-i18next";
import ProductCard from "../../sales/catalog/productCard";
import ProductCardNew from "../../sales/catalog/productCardNew";
import ComponentDialog from "../component/componentDialog";
import Breadcrumb from "../../../component/breadcrumb";
import Input from "../../../component/inputpm";
import Autocomplete from "@mui/material/Autocomplete";
import EditIcon from "@mui/icons-material/Edit";
import ClearIconMUI from "@mui/icons-material/Clear";
import { Tooltip } from "@mui/material";
import ManageCustomersHierarchy from "../../sales/manageCustomers/manageCustomersHierarchy";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Paper,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import currencyFormatter from "../../../helper/currencyFormatter";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
import ProductTable from "../../sales/catalog/productTable";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import classes from "../component/component.module.css";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import DehazeIcon from "@mui/icons-material/Dehaze";
import {
  SearchIcon,
  RefreshIcon,
  ClearIcon,
  AdvanceSearchIcon,
  DetailView,
  ListView,
  PlusIcon,
} from "../../../component/icons/icons";
import CloseIcon from "@mui/icons-material/Close";
import Draggable from "react-draggable";
import jp from "jsonpath";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Card from "@mui/material/Card";
import { DeleteIconNew, EditIconNew } from "../../../component/icons/icons.js";
import CustomAttributeSearch from "../packagedSolutionList/customAttributeSearch.js";
import { ButtonGroup } from "@mui/material";
// import { withStyles } from '@mui/styles';
import { withNavigation } from "../../../helper/withNavigation.js";
import { formatNumber } from "../../../helper/numberFormatter";

// Edit Packaged Soltuion page class
class PackagedSolutionList extends Component {
  // Declare property values that belongs to the component
  state = {
    products: [],
    groupedProducts: [],
    categoryOptions: [],
    partnerOptions: [],
    category: "",
    partner: "",
    loading: false,
    bread: [],
    confirmationDialog: false,
    displayAvailableMsg: false,
    showError: false,
    firstCategoryKey: "Connectivity",

    productToEdit: {},
    componentType: "",
    showEditProduct: false,
    activationResourceList: [],
    provisioningResourceList: [],
    suspendResourceList: [],
    resumeResourceList: [],
    categoryList: [],
    availableProductsLength: 0,

    customersList: [],
    selectedCustomer: {},
    selectedCustomerName: "",
    showCustomerDialog: false,
    customerData: [],
    customerDataProxy: [],
    openConfirmCustomer: false,
    viewMode: "",
    perPage: 10,
    page: 1,
    startRecord: 1,
    totalCount: 0,
    allProducts: [],
    allProductsProxy: [],
    allOriginalProducts: [],
    productName: "",
    productErrorMessage: "",
    channelList: [],
    preQualResourcesList: [],
    productCode: "",
    allBucketsList: [],
    productCategoryList: [],
    stateFilterList: [],
    categoryFilterList: [],
    selectedState: "all_offerings",
    selectedCategory: "all_offerings",
    allOtherPricesList: [
      {
        name: "DEPOSIT_PRICE",
        value: "DEPOSIT",
        disabled: false,
      },
      {
        name: "CANCELLATION_PRICE",
        value: "CANCELLATION_PRICE",
        disabled: false,
      },
      {
        name: "SHIFT_PRICE",
        value: "SHIFT_PRICE",
        disabled: false,
      },
      {
        name: "SUSPENSION_PRICE",
        value: "SUSPENSION_PRICE",
        disabled: false,
      },
      {
        name: "REACTIVATION_PRICE",
        value: "REACTIVATION_PRICE",
        disabled: false,
      },
      {
        name: "USAGE_CHARGE",
        value: "USAGE_CHARGE",
        disabled: false,
      },
    ],
    priceOptions: [],
    customAttributesList: [],
    formData: [],
    childEnable: false,
    clearFilterTrigger: false,
    showChild: false,
  };

  // Intial HTTP calls or data manipulation on page load
  async componentDidMount() {
    const storedViewMode = localStorage.getItem("viewMode");
    this.setState({
      viewMode: storedViewMode || "Card",
    });
    if (
      this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
      this.props.loggedInUserType === "ECOMMERCE_ADMIN"
    ) {
      var customerData = JSON.parse(localStorage.getItem("ecommerceCustData"));
      var customerList = [...this.state.customerData];
      customerList.push(customerData);
      this.setState({
        customerData: customerList,
      });
    }
    localStorage.removeItem("selectedAvailableSolutionProvider");
    this.getAvailableProductsLength();
    this.getCustomersList();
    // Remove error message on component load
    this.props.setCompDidMount();
    this.setState({ loading: true });

    let search = new URLSearchParams(this.props.router.location.search);
    let promoSuccess = search.get("promoSuccess");

    if (promoSuccess) {
      this.props.setErrorMessage(
        this.props.t("SPECIAL_PROMO_PRICE_CREATED_SUCCESSFULLY"),
        true,
      );
    }

    //get the menus
    let apiCall = "";
    if (this.props.providerType === "SALES_CHNL_PROVIDER") {
      apiCall = `${constants.busV4Url}/providers/ALL_PROVIDERS/solutionProviderProductMenus`;
    } else {
      apiCall = `${constants.busV4Url}/providers/${this.props.providerId}/menus`;
    }
    BusApiCall("GET", apiCall)
      .then((res) => {
        this.setState({
          categoryOptions: res.data.menuFilteredByCategory,
          categoryList: res.data.menuCategories,
          partnerOptions: [],
          // loading: false
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        // this.setState({ loading: false })
      });

    //get solutions
    if (this.props.router.location.pathname === "/myOfferings") {
      let bread = [
        { title: this.props.t("MY_SOLUTIONS"), url: "/myOfferings" },
      ];
      this.setState({ bread });
      this.getMyButcketsList();
      this.getCategories();
      this.getChannelsList();
      this.getStates();
      if (
        this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
        this.props.loggedInUserType === "ECOMMERCE_ADMIN"
      ) {
        var customerData = JSON.parse(
          localStorage.getItem("ecommerceCustData"),
        );
        var customerList = [...this.state.customerData];
        customerList.push(customerData.partyId);
        this.setState(
          {
            customerData: customerList,
          },
          () => {
            var offeringListingFilters = localStorage.getItem(
              "offeringListingFilters",
            );
            if (offeringListingFilters) {
              var filters = JSON.parse(offeringListingFilters);
              this.setState(
                {
                  // customerData: filters.customerData,
                  productName: filters.productName,
                  selectedState: filters.selectedState,
                  selectedCategory: filters.selectedCategory,
                  productCode: filters.productCode,
                },
                () => {
                  this.myOfferings();
                },
              );
            } else {
              this.myOfferings();
            }
            // this.myOfferings()
          },
        );
      } else {
        // this.myOfferings()
        var offeringListingFilters = localStorage.getItem(
          "offeringListingFilters",
        );
        if (offeringListingFilters) {
          var filters = JSON.parse(offeringListingFilters);
          this.setState(
            {
              customerData: filters.customerData,
              productName: filters.productName,
              selectedState: filters.selectedState,
              selectedCategory: filters.selectedCategory,
              productCode: filters.productCode,
            },
            () => {
              this.myOfferings();
            },
          );
        } else {
          this.myOfferings();
        }
      }
    } else if (this.props.router.location.pathname === "/availableOfferings") {
      let bread = [
        {
          title: this.props.t("AVAILABLE_SOLUTIONS"),
          url: "/availableOfferings",
        },
      ];
      this.setState({ bread });
      this.available();
    }
  }

  setShowChild = () => {
    const ooredooTenants = ["ooredoo", "ordkw", "ordgroup", "qatarooredoo"]; // List of Ooredoo tenants
    const checkTenantId = this.props.providerId;
    // console.log('customattributes length============', this.state.customAttributesList.length)
    if (
      checkTenantId &&
      ooredooTenants.includes(checkTenantId) &&
      this.state.customAttributesList.length > 0
    ) {
      this.setState({ showChild: true }); // Set default visibility to true
    }
  };

  handleChildStateChange = (value) => {
    this.setState({ formData: value });
  };

  toggleChildVisibility = () => {
    this.setState((prevState) => ({
      showChild: !prevState.showChild, // Toggle the state
    }));
    if (this.state.showChild) {
      this.state.formData = "";
    }
  };

  getMyButcketsList = () => {
    Promise.all([
      BusApiCall("GET", `${constants.busV4Url}/catalog/myComponentTypes`),
      BusApiCall("GET", `${constants.busV4Url}/catalog/allComponentTypes`),
    ])
      .then((res) => {
        let myComponentData = res[0].data;
        let allComponentData = res[1].data;
        let cData = JSON.parse(myComponentData.jsonResponse);
        var index = cData.findIndex((a) => a.id === "PROD_COMP_REF_PKG");
        if (index > -1) {
          cData.splice(index, 1);
        }
        let globalProdData = JSON.parse(allComponentData.jsonResponse);
        cData.push(...globalProdData.globalProducts);
        if (cData && cData.length > 0) {
          this.setState(
            {
              allBucketsList: cData,
            },
            () => { },
          );
        } else {
          this.props.setErrorMessage(
            this.props.t("NO_COMPONENT_TYPE_FOUND"),
            false,
          );
        }
        let allCustomAttrList = [];
        let customAttributesList = [];
        if (globalProdData && globalProdData.unMappedTypes.length > 0) {
          for (var i = 0; i < globalProdData.unMappedTypes.length; i++) {
            if (globalProdData.unMappedTypes[i].id == "PROD_COMP_ALL") {
              allCustomAttrList = JSON.parse(
                JSON.stringify(
                  globalProdData.unMappedTypes[i].customAttributes
                    ? globalProdData.unMappedTypes[i].customAttributes
                    : [],
                ),
              );
              //console.log("customAttributesList==========---======",customAttributesList);
              allCustomAttrList.forEach((item) => {
                if (item.searchable) {
                  customAttributesList.push(item);
                }
              });
            }
          }

          this.setState(
            { customAttributesList: customAttributesList, childEnable: true },
            () => {
              //console.log("---------allCustomAttrList--------",allCustomAttrList
              // this.setShowChild(); //commenting this out to avoid the default value of showChild being true irrespective of the tenant
            },
          );
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        onDrag={this.onDragHandler}
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  onDragHandler = (event, data) => {
    console.log("check drag event xxx", event.x);
    console.log("check drag data", event.y);
  };

  getCustomersList = () => {
    let pageOptions = {
      batchSize: 100,
      startRecord: 1,
    };
    let jsonData = {};
    BusApiCall(
      "GET",
      `${constants.busV4Url}/parties/${this.props.providerId}/hierarchy?name=&ban=&level=1`,
      jsonData,
      pageOptions,
    )
      .then((res) => {
        this.setState({
          customersList: res.data.customers,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // get the available solutions for all providers
  available = () => {
    this.setState({
      loading: true,
      products: [],
    });
    // Request to fetch Packaged Solutions data
    BusApiCall("GET", `${constants.busV44Url}/pm/availableProductOfferings`)
      //BusApiCall('GET', `${constants.busV4Url}/providers/ALL_PROVIDERS/solutionProviderProducts`)
      .then((res) => {
        let allSols = JSON.parse(JSON.stringify(res.data));
        if (allSols) {
          if (Array.isArray(allSols)) {
          } else {
            allSols = [];
          }
        } else {
          allSols = [];
        }
        // var approvedSols = allSols.filter(p => p.isApproved);
        var approvedSols = allSols;
        this.setState(
          {
            products: approvedSols,
            displayAvailableMsg: true,
            loading: false,
            showError: approvedSols.length === 0 ? true : false,
          },
          () => {
            this.changeCategory();
          },
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  getAvailableProductsLength = () => {
    BusApiCall(
      "GET",
      `${constants.busV44Url}/pm/availableProductOfferings`,
    ).then((res) => {
      let allSols = JSON.parse(JSON.stringify(res.data));
      this.setState({
        availableProductsLength: allSols.length,
      });
    });
  };

  // get my solutions for sepecific providers
  myOfferings = () => {
    this.setState({
      loading: true,
      products: [],
    });
    var customerIds = this.state.customerData.map((value) => {
      return value.partyId;
    });
    let pageOptions = {
      batchSize: this.state.perPage,
      startRecord: this.state.startRecord,
    };
    // Request to fetch Packaged Solutions data
    //BusApiCall('GET', `${constants.busV44Url}/pm/productOfferings?customer=${customerIds.join()}&productName=${this.state.productName}&productCode=${this.state.productCode}&productCategoryId=${this.state.selectedCategory === 'all_offerings' ? '' : this.state.selectedCategory}`, {}, pageOptions)
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productOfferings?myOfferings=true&richText=false&sortBy=${this.state.sortBy ? this.state.sortBy : "name"}&sortOrder=${this.state.sortOrder ? this.state.sortOrder : "ASC"}${this.state.isSubscriptionMode ? (this.state.subscriptionMode != "NewActivation" ? "&orderType=" + this.state.subscriptionMode : "") : ""}${customerIds.length > 0 ? "&customer=" + customerIds.join() : ""}${this.state.productName ? "&productName=" + this.state.productName : ""}${this.state.productCode ? "&productCode=" + this.state.productCode : ""}${this.state.formData && this.state.formData != "-" ? this.state.formData : ""}${this.state.selectedCategory !== "all_offerings" ? "&productCategoryId=" + this.state.selectedCategory : ""}${this.state.selectedState !== "all_offerings" && this.state.selectedState !== undefined ? "&state=" + this.state.selectedState : ""}`,
      this.props.providerType === "SOLUTION_PROVIDER" &&
        this.props.router.location.pathname === "/newOrder"
        ? {
          tenantId:
            this.state.providerId !== ""
              ? this.state.providerId
              : this.state.tenantList[0]
                ? this.state.tenantList[0].tenantId
                : "",
        }
        : {},
      pageOptions,
    )
      //BusApiCall('GET', `${constants.busV4Url}/providers/${this.props.providerId}/solutions`)
      .then((res) => {
        var tempProducts = [];
        // for (var i = 0; i < res.data.length; i++) {
        //     var item = res.data[i];
        //     item.category = res.data[i].categories[0].categoryName;
        //     tempProducts.push(item);
        // }
        // var sortedTempProdcuts = tempProducts.sort((a, b) => (a.category > b.category ? 1 : b.category > a.category ? -1 : 0));
        // this.setState({
        //     products: res.data,
        //     displayAvailableMsg: true,
        //     showError: res.data.length === 0 ? true : false,
        //     allOriginalProducts: sortedTempProdcuts,

        //     totalCount: +res.headers['x-total-count'],
        //     allProductsProxy: sortedTempProdcuts,
        // }, () => {
        //     // this.changeCategory();
        //     // this.paginateTable();
        //     // this.filterProductsTable();
        //     // this.setState({ loading: false });
        //     this.updateFilters();
        //     this.paginateTable();
        // })
        for (var i = 0; i < res.data.length; i++) {
          var item = res.data[i];
          item.category = res.data[i].category.name;
          item.productId = res.data[i].productOfferingId;
          item.isBundle = true;
          for (var j = 0; j < item.attachments.length; j++) {
            if (item.attachments[j].type === "IMAGE") {
              item.largeImageUrl = item.attachments[j].url;
            }
          }
          tempProducts.push(item);
        }
        //console.log('----------tempProducts',tempProducts);
        var sortedTempProdcuts = tempProducts.sort((a, b) =>
          a.category > b.category ? 1 : b.category > a.category ? -1 : 0,
        );
        this.setState(
          {
            products: tempProducts,
            displayAvailableMsg: true,
            showError: res.data.length === 0 ? true : false,
            totalCount: +res.headers["x-total-count"],
            allProductsProxy: sortedTempProdcuts,
          },
          () => {
            this.paginateTable();
            this.setState({ loading: false });
            //console.log('----------products--',this.state.products);
          },
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // Change category
  changeCategory = (e) => {
    let defaultCat = "";
    //COMMENT : commented this as curretly this funationality is not needed.
    // let found = (this.state.categoryOptions).some(item => item.categoryId === 'FLEET_CAT');
    // if (found) {
    //     defaultCat = 'FLEET_CAT';
    // } else {
    //     defaultCat = '';
    // }
    let value = e ? e.target.value : defaultCat;
    let firstCat = this.state.firstCategoryKey;
    if (this.props.router.location.pathname === "/myOfferings") {
      if (value === "") {
        let data = this.state.products;
        let groupedData = data.reduce(function (r, a) {
          let catName = a.categories[0].categoryName;
          if (firstCat && catName && catName.startsWith(firstCat)) {
            catName = " " + catName;
          }
          r[catName] = r[catName] || [];
          r[catName].push(a);
          return r;
        }, Object.create(null));
        this.setState({
          groupedProducts: groupedData,
          category: value,
        });
      } else {
        let data = [];
        for (let i = 0; i < this.state.products.length; i++) {
          if (this.state.products[i].categoryIds.includes(value)) {
            data.push(this.state.products[i]);
          }
        }
        let groupedData = data.reduce(function (r, a) {
          let catName = a.categories[0].categoryName;
          if (firstCat && catName.startsWith(firstCat)) {
            catName = " " + catName;
          }
          r[catName] = r[catName] || [];
          r[catName].push(a);
          return r;
        }, Object.create(null));
        this.setState({
          category: value,
          groupedProducts: groupedData,
        });
      }
    } else {
      if (value === "") {
        let data = this.state.products;
        let groupedData = data.reduce(function (r, a) {
          r[a.vendorPartyName] = r[a.vendorPartyName] || [];
          r[a.vendorPartyName].push(a);
          return r;
        }, Object.create(null));

        this.setState({
          groupedProducts: groupedData,
          category: value,
        });
      } else {
        let data = [];
        for (let i = 0; i < this.state.products.length; i++) {
          if (this.state.products[i].categoryIds.includes(value)) {
            data.push(this.state.products[i]);
          }
        }
        let groupedData = data.reduce(function (r, a) {
          r[a.vendorPartyName] = r[a.vendorPartyName] || [];
          r[a.vendorPartyName].push(a);
          return r;
        }, Object.create(null));

        this.setState({
          category: value,
          groupedProducts: groupedData,
        });
      }
    }
  };

  // Change partner
  changePartner = (e) => {
    this.setState({
      partner: e.target.value,
    });
  };

  // FIlter packaged soltuions by Category and partner
  filterFunction = (product) => {
    const partner = this.state.partner;
    const category = this.props.category;
    if (
      (category === "" || product.categoryIds.includes(category.categoryId)) &&
      (partner === "" || product.vendorPartyId === partner)
    ) {
      return true;
    }
    return false;
  };

  //removeProduct from the catalog for the sales channel provider
  removeProduct = (productId, index) => {
    this.setState({
      removeIndex: index,
      removeId: productId,
      confirmationDialog: true,
    });
  };

  //remove based on the action from the dialog box
  removeConfirmation = (remove) => {
    let productList = [...this.state.products];
    if (remove) {
      this.setState({ loading: true });
      BusApiCall(
        "DELETE",
        `${constants.busV4Url}/providers/${this.props.providerId}/products/${this.state.removeId}`,
      )
        .then((res) => {
          // productList.splice(this.state.removeIndex, 1);
          // this.setState({
          //     loading: false,
          //     confirmationDialog: false
          // }, () => {
          //     this.setState({
          //         products: productList
          //     }, () => {
          //         this.changeCategory();
          //         this.props.setErrorMessage(this.props.t('PACKAGED_SOLUTION_REMOVED_SUCCESSFULLY'), true)
          //     })
          // })
          this.myOfferings();
          this.setState({
            confirmationDialog: false,
          });
          if (res && res.data.errorMessage) {
            this.props.setErrorMessage(this.props.t(res.data.errorMessage), false)
          }
          else {
            this.props.setErrorMessage(this.props.t('PACKAGED_SOLUTION_REMOVED_SUCCESSFULLY'), true)
          }
        })
        .catch((err) => {
          this.setState({ loading: false });
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        });
    } else {
      this.setState({ confirmationDialog: false });
    }
  };

  viewContracts = (id, key) => {
    localStorage.setItem("selectedAvailableSolutionProvider", key);
    this.props.router.navigate(`${id}/contracts`);
  };

  editStandaloneProduct = (componentId, componentType) => {
    this.setState(
      {
        loading: true,
        componentType: componentType,
      },
      () => {
        Promise.all([
          BusApiCall(
            "GET",
            `${constants.busV4Url}/resources?type=PROVISIONING&associationType=${componentType}`,
          ), // 0
          BusApiCall(
            "GET",
            `${constants.busV4Url}/resources?type=ACTIVATION&associationType=${componentType}`,
          ), // 1
          BusApiCall(
            "GET",
            `${constants.busV4Url}/resources?type=SUBSCRIPTION_SUSPEND&associationType=${componentType}`,
          ), // 2
          BusApiCall(
            "GET",
            `${constants.busV4Url}/resources?type=SUBSCRIPTION_RESUME&associationType=${componentType}`,
          ), // 3
          BusApiCall(
            "GET",
            `${constants.busV4Url}/resources?type=QUALIFICATION&associationType=${componentType}`,
          ), // 4
          BusApiCall(
            "GET",
            `${constants.busV44UrlPublic}/product/${componentId}`,
          ), // 5
        ])
          .then((res) => {
            // Set provisioning resources
            var tempProv = res[0].data.resourceList;
            var provResources = [];
            if (tempProv && tempProv.length > 0) {
              var sortedProv = tempProv.sort((a, b) =>
                a.resourceName > b.resourceName
                  ? 1
                  : b.resourceName > a.resourceName
                    ? -1
                    : 0,
              );
              sortedProv.forEach(function (item, i) {
                if (item.resourceId === "NOOP_ACT") {
                  sortedProv.splice(i, 1);
                  sortedProv.unshift(item);
                }
              });
              provResources = sortedProv;
            }

            // Set activation resources
            var tempAct = res[1].data.resourceList;
            var actResources = [];
            if (tempAct && tempAct.length > 0) {
              var sortedAct = tempAct.sort((a, b) =>
                a.resourceName > b.resourceName
                  ? 1
                  : b.resourceName > a.resourceName
                    ? -1
                    : 0,
              );
              sortedAct.forEach(function (item, i) {
                if (item.resourceId === "NOOP_ACT") {
                  sortedAct.splice(i, 1);
                  sortedAct.unshift(item);
                }
              });
              actResources = sortedAct;
            }

            // Set suspend resources
            var tempSuspend = res[2].data.resourceList;
            var suspendResources = [];
            if (tempSuspend && tempSuspend.length > 0) {
              var sortedSuspend = tempSuspend.sort((a, b) =>
                a.resourceName > b.resourceName
                  ? 1
                  : b.resourceName > a.resourceName
                    ? -1
                    : 0,
              );
              sortedSuspend.forEach(function (item, i) {
                if (item.resourceId === "NOOP_ACT") {
                  sortedSuspend.splice(i, 1);
                  sortedSuspend.unshift(item);
                }
              });
              suspendResources = sortedSuspend;
            }

            // Set resume resources
            var tempResume = res[3].data.resourceList;
            var resumeResources = [];
            if (tempResume && tempResume.length > 0) {
              var sortedResume = tempResume.sort((a, b) =>
                a.resourceName > b.resourceName
                  ? 1
                  : b.resourceName > a.resourceName
                    ? -1
                    : 0,
              );
              sortedResume.forEach(function (item, i) {
                if (item.resourceId === "NOOP_ACT") {
                  sortedResume.splice(i, 1);
                  sortedResume.unshift(item);
                }
              });
              resumeResources = sortedResume;
            }

            // Qualification resources
            var tempQual = res[4].data.resourceList;
            var qualResources = [];
            if (tempQual && tempQual.length > 0) {
              var sortedQual = tempQual.sort((a, b) =>
                a.resourceName > b.resourceName
                  ? 1
                  : b.resourceName > a.resourceName
                    ? -1
                    : 0,
              );
              sortedQual.forEach(function (item, i) {
                if (item.resourceId === "NOOP_ACT") {
                  sortedQual.splice(i, 1);
                  sortedQual.unshift(item);
                }
              });
              qualResources = sortedQual;
            }

            // Product data
            var tempProductData = res[5].data;
            var finalProductData = {
              featureCode: tempProductData.productCode,
              sellable: tempProductData.sellable,
              description: tempProductData.description,
              internalName: tempProductData.name,
              price: tempProductData.price.priceAmount,
              assembly: tempProductData.assembly,
              id: tempProductData.productId,
              componentName: tempProductData.category
                ? tempProductData.category.name
                : "",
              physical: tempProductData.physical,
              inventoried: tempProductData.inventoried,
              isCustomerViewable: tempProductData.customerViewable,
              componentType: tempProductData.category
                ? tempProductData.category.id
                : "",
              priceTenureUOM: tempProductData.price.priceTenureUOM,
              priceTenure: tempProductData.price.priceTenure,
              priceType:
                tempProductData.price.priceType === "NTC"
                  ? "NTC"
                  : tempProductData.price.priceType === "NR"
                    ? "NRC"
                    : "RC",
              name: tempProductData.name,
              customer: tempProductData.customer
                ? tempProductData.customer
                : [],
              bom: tempProductData.bom,
              provisioning: tempProductData.provisioning
                ? tempProductData.provisioning
                : {},
              activation: tempProductData.activation
                ? tempProductData.activation
                : {},
              suspendResource: tempProductData.suspendResource
                ? tempProductData.suspendResource
                : {},
              resumeResource: tempProductData.resumeResource
                ? tempProductData.resumeResource
                : {},
              customAttributes: [],
              inventoryItemType:
                tempProductData.inventoryItemType === ""
                  ? "NON_SERIALIZED_ITEM"
                  : tempProductData.inventoryItemType === "NON_SERIAL_INV_ITEM"
                    ? "NON_SERIALIZED_ITEM"
                    : "SERIALIZED_ITEM",
              preQuals: [],
              variants: [],
              enrichmentConfig: {},
              localisedName: [],
              localisedDesc: [],

              resourceId: "",
              rawMaterial: false,
              inventoryDetails: null,
              language: "",

              // fromProviderType: "",
              // fromProviderId: '',
              // fromProviderName: '',
              // isStandAlone: '',
              // children: [],
            };

            if (
              tempProductData.qualifications &&
              tempProductData.qualifications.length > 0
            ) {
              for (var i = 0; i < tempProductData.qualifications.length; i++) {
                var qual = tempProductData.qualifications[i];
                if (typeof qual.extraFields === "string") {
                  qual.extraFields = {};
                }
                finalProductData.preQuals.push(qual);
              }
            }

            if (
              tempProductData.i18nName &&
              tempProductData.i18nName.length > 0
            ) {
              finalProductData.localisedName = tempProductData.i18nName;
            }
            if (
              tempProductData.i18nDesc &&
              tempProductData.i18nDesc.length > 0
            ) {
              finalProductData.localisedDesc = tempProductData.i18nDesc;
            }
            if (tempProductData.sellable) {
              finalProductData.basicDetail = {
                categoryId: tempProductData.category
                  ? tempProductData.category.id
                  : "",
                productOverview: "",
                productTechSpecs: "",
                productWhatsIncluded: "",
                productMainImage: "",
                productMainImageSource: "",
                productName: tempProductData.name,
                productDescription: tempProductData.description,
                startingPrice: tempProductData.price.priceAmount,

                productAdditionalImage1: "",
                productAdditionalImage2: "",
                productAdditionalImage3: "",
                productAdditionalImage4: "",
                productAdditionalImage1Src: "",
                productAdditionalImage2Src: "",
                productAdditionalImage3Src: "",
                productAdditionalImage4Src: "",
                terms: [],
                overrideStartingPrice: false,
              };
              for (var a = 0; a < tempProductData.attachments.length; a++) {
                if (tempProductData.attachments[a].type === "IMAGE") {
                  finalProductData.basicDetail.productMainImage =
                    tempProductData.attachments[a].url;
                }
                if (tempProductData.attachments[a].type === "WHATSINCLUDED") {
                  finalProductData.basicDetail.productWhatsIncluded =
                    tempProductData.attachments[a].richText;
                }
                if (tempProductData.attachments[a].type === "SPECIFICATION") {
                  finalProductData.basicDetail.productTechSpecs =
                    tempProductData.attachments[a].richText;
                }
                if (tempProductData.attachments[a].type === "OVERVIEW") {
                  finalProductData.basicDetail.productOverview =
                    tempProductData.attachments[a].richText;
                }
              }
              finalProductData.releaseDate = tempProductData.releaseDate;
              finalProductData.expiryDate = tempProductData.expiryDate;
            }

            // set variants
            if (
              tempProductData.variants &&
              tempProductData.variants.length > 0
            ) {
              for (var i = 0; i < tempProductData.variants.length; i++) {
                finalProductData.variants.push({
                  name: tempProductData.variants[i].name,
                  price: tempProductData.variants[i].price,
                  productId: tempProductData.variants[i].productId,
                  description: tempProductData.variants[i].description,
                  featureCode: tempProductData.variants[i].productCode,
                  deleteId: null,
                  settlementContentId: null,
                  componentsProvider: null,
                  componentsProviderType: null,
                  inventoryItemTypeId: null,
                });
              }
            }
            // set custom attributes
            var originalBucket = jp.query(
              this.state.allBucketsList,
              '$[?(@.id=="' + componentType + '")]',
            );
            var originalBucketAttributes = originalBucket[0].customAttributes;
            if (Object.keys(tempProductData.attributes).length > 0) {
              Object.keys(tempProductData.attributes).map((key) => {
                var tempIndex = originalBucketAttributes.findIndex(
                  (x) => x.attrName === key,
                );
                if (tempIndex > -1) {
                  var tempAttribute = {
                    create: false,
                    delete: false,
                    update: false,
                    productId: tempProductData.productId,
                    valueType: originalBucketAttributes[tempIndex].valueType,
                    attrType: "CUSTOM_ATTRIBUTE",
                    attrName: key,
                    attrValue: tempProductData.attributes[key],
                    required: originalBucketAttributes[tempIndex].required,
                    options: originalBucketAttributes[tempIndex].options,
                  };
                  finalProductData.customAttributes.push(tempAttribute);
                }
              });
            }

            // set enrichment configurations
            var tempEnrichmentConfig = {
              visible: [],
              removeable: [],
              purchaseable: [],
              rePurchaseable: [],
            };
            if (
              tempProductData.visibiltyOptions &&
              tempProductData.visibiltyOptions.length > 0
            ) {
              for (var i = 0; i < this.state.channelList.length; i++) {
                var tempIndex = tempProductData.visibiltyOptions.findIndex(
                  (x) => x.channelName === this.state.channelList[i].value,
                );
                if (tempIndex > -1) {
                  tempEnrichmentConfig.visible.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .visible,
                  );
                  tempEnrichmentConfig.removeable.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .removable,
                  );
                  tempEnrichmentConfig.purchaseable.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .purchasable,
                  );
                  tempEnrichmentConfig.rePurchaseable.push(
                    this.state.channelList[i].id +
                    ":" +
                    tempProductData.visibiltyOptions[tempIndex].visibility
                      .rePurchasable,
                  );
                }
              }
            }
            finalProductData.enrichmentConfig = {
              visible: tempEnrichmentConfig.visible.join(),
              removeable: tempEnrichmentConfig.removeable.join(),
              purchaseable: tempEnrichmentConfig.purchaseable.join(),
              rePurchaseable: tempEnrichmentConfig.rePurchaseable.join(),
            };
            this.setState(
              {
                activationResourceList: actResources,
                provisioningResourceList: provResources,
                suspendResourceList: suspendResources,
                resumeResourceList: resumeResources,
                preQualResourcesList: qualResources,
                productToEdit: finalProductData,
              },
              () => {
                this.setState({ showEditProduct: true, loading: false });
              },
            );
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({ loading: false });
          });
      },
    );

    return;
    this.setState(
      {
        loading: true,
        componentType: componentType,
      },
      () => {
        this.getResources("ACTIVATION");
        this.getResources("PROVISIONING");
        this.getResources("SUBSCRIPTION_SUSPEND");
        this.getResources("SUBSCRIPTION_RESUME");
        this.getResources("QUALIFICATION");
        this.getCategories();
        this.getChannelsList();
      },
    );
    BusApiCall(
      "GET",
      `${constants.busV4Url}/catalogs/products?componentType=${componentType}&mode=component&componentId=${componentId}&customer=${this.state.customerId ? this.state.customerId : ""}`,
    )
      .then((res) => {
        if (res.data.length > 0) {
          let data = res.data[0];
          this.setState({
            productToEdit: data,
            showEditProduct: true,
          });
        } else {
          this.props.setErrorMessage(this.props.t("PRODUCT_NOT_FOUND"), false);
        }

        this.setState({ loading: false });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  getResources = (resourceType) => {
    this.setState({ loading: true });
    BusApiCall(
      "GET",
      `${constants.busV4Url}/resources?type=${resourceType}&associationType=${this.state.componentType}`,
    )
      .then((res) => {
        let data = res.data;
        if (data && data.resourceList && data.resourceList.length > 0) {
          data.resourceList.sort((a, b) =>
            a.resourceName > b.resourceName
              ? 1
              : b.resourceName > a.resourceName
                ? -1
                : 0,
          );
          if (resourceType === "ACTIVATION") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_ACT") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            this.setState(
              {
                activationResourceList: list,
              },
              () => {
                // this.setState({ loading: false })
              },
            );
          } else if (resourceType === "PROVISIONING") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_PROV") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            this.setState(
              {
                provisioningResourceList: list,
              },
              () => {
                // this.setState({ loading: false })
              },
            );
          } else if (resourceType === "SUBSCRIPTION_SUSPEND") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_SUB_SUSPEND") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            this.setState(
              {
                suspendResourceList: list,
              },
              () => {
                // this.setState({ loading: false })
              },
            );
          } else if (resourceType === "SUBSCRIPTION_RESUME") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_SUB_RESUME") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            this.setState(
              {
                resumeResourceList: list,
              },
              () => {
                // this.setState({ loading: false })
              },
            );
          } else if (resourceType === "QUALIFICATION") {
            let list = data.resourceList;
            list.forEach(function (item, i) {
              if (item.resourceId === "NOOP_SUB_RESUME") {
                list.splice(i, 1);
                list.unshift(item);
              }
            });
            this.setState(
              {
                preQualResourcesList: list,
              },
              () => {
                // this.setState({ loading: false })
              },
            );
          }
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  closeComponentDialog = (val) => {
    if (val) {
      if (val.children) {
        for (var i = 0; i < val.children.length; i++) {
          delete val.children[i].expandKitComponents;
        }
      }
      val.assembly = this.state.addComponentType === "assembly" ? true : false;
      val.name = val.name.trim();
      val.description = val.description.trim();
      this.setState({ loading: true });
      for (var i = 0; i < val.customAttributes.length; i++) {
        if (val.customAttributes[i].valueType === "boolean") {
          val.customAttributes[i].attrValue =
            "" + val.customAttributes[i].attrValue;
        }
      }
      if (this.state.mode === "add" || this.state.mode === "kit") {
      } else {
        delete val.inventoryItemAndDetail;
        delete val.productType;
        if (val.bom && val.bom.length > 0) {
          val.bom.forEach(function iter(a) {
            delete a.productType;
            Array.isArray(a.bom) && a.bom.forEach(iter);
          });
        }
        if (val.bom && val.bom.length > 0) {
          val.bom.forEach(function iter(a) {
            delete a.inventoryItemAndDetail;
            Array.isArray(a.bom) && a.bom.forEach(iter);
          });
        }
        BusApiCall(
          "PATCH",
          `${constants.busV4Url}/components/products/${this.state.productToEdit.id}`,
          val,
        )
          .then((res) => {
            this.myOfferings();
            this.setState({
              activationResourceList: [],
              resumeResourceList: [],
              suspendResourceList: [],
              provisioningResourceList: [],
              productToEdit: {},
              showEditProduct: false,
              loading: false,
            });
            this.props.setErrorMessage(
              this.props.t("PRODUCT_UPDATED_SUCCESSFULLY"),
              true,
            );
          })
          .catch((err) => {
            this.myOfferings();
            this.setState({
              activationResourceList: [],
              resumeResourceList: [],
              suspendResourceList: [],
              provisioningResourceList: [],
              productToEdit: {},
              showEditProduct: false,
              loading: false,
            });
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
          });
      }
    } else {
      this.setState({
        activationResourceList: [],
        resumeResourceList: [],
        suspendResourceList: [],
        provisioningResourceList: [],
        productToEdit: {},
        showEditProduct: false,
        loading: false,
      });
    }
  };

  toggleViewMode = () => {
    const { viewMode } = this.state;
    const newViewMode = viewMode === "Card" ? "Table" : "Card";
    this.setState({
      viewMode: newViewMode,
    });
    localStorage.setItem("viewMode", newViewMode);
  };

  onCustomerInputChange = (e, value) => {
    this.setState({
      selectedCustomerName: value,
    });
  };

  clearCustomerSelection = () => {
    this.setState(
      {
        customerData: [],
        customerDataProxy: [],
      },
      () => {
        this.updateFilters();
        this.myOfferings();
      },
    );
  };

  changeCustomerCheck = () => {
    this.changeCustomer();
  };

  changeCustomer = () => {
    this.setState({
      customerDataProxy: [...this.state.customerData],
      showCustomerDialog: true,
      openConfirmCustomer: false,
    });
  };

  selectCustomers = (customer) => {
    var customers = [...this.state.customerDataProxy];
    var index = customers.findIndex((x) => x.partyId === customer.partyId);
    if (index > -1) {
      customers.splice(index, 1);
    } else {
      customers.push(customer);
    }
    this.setState(
      {
        customerDataProxy: customers,
      },
      () => {
        // this.myOfferings();
      },
    );
  };

  closeChangeCustomer = (val) => {
    this.setState(
      {
        customerData: val
          ? [...this.state.customerDataProxy]
          : [...this.state.customerData],
        showCustomerDialog: false,
      },
      () => {
        this.updateFilters();
        if (val) {
          this.myOfferings();
        }
      },
    );
  };

  updateFilters = () => {
    var offeringListingFilters = {
      customerData: this.state.customerData,
      productName: this.state.productName,
      productCode: this.state.productCode,
      selectedState: this.state.selectedState,
      selectedCategory: this.state.selectedCategory,
    };
    localStorage.setItem(
      "offeringListingFilters",
      JSON.stringify(offeringListingFilters),
    );
  };

  paginateTable = () => {
    window.scrollTo(0, 0);
    var offerings = this.state.allProductsProxy;
    // .slice((this.state.page - 1) * this.state.perPage, this.state.page * this.state.perPage);
    let value = "";
    // let firstCat = this.state.firstCategoryKey;
    let firstCat = "";
    if (this.props.router.location.pathname === "/myOfferings") {
      if (value === "") {
        let data = offerings;
        let groupedData = data.reduce(function (r, a) {
          let catName = a.category;
          if (firstCat && catName && catName.startsWith(firstCat)) {
            catName = " " + catName;
          }
          r[catName] = r[catName] || [];
          r[catName].push(a);
          return r;
        }, Object.create(null));
        this.setState({
          groupedProducts: groupedData,
          category: value,
          loading: false,
        });
      } else {
        let data = [];
        for (let i = 0; i < offerings.length; i++) {
          if (offerings[i].categoryIds.includes(value)) {
            data.push(offerings[i]);
          }
        }
        let groupedData = data.reduce(function (r, a) {
          let catName = a.category;
          if (firstCat && catName.startsWith(firstCat)) {
            catName = " " + catName;
          }
          r[catName] = r[catName] || [];
          r[catName].push(a);
          return r;
        }, Object.create(null));
        this.setState({
          groupedProducts: groupedData,
          category: value,
          loading: false,
        });
      }
    }
    // return offerings.reduce(function (r, a) {
    //     let catName = a.categories[0].categoryName;
    //     if (firstCat && catName && catName.startsWith(firstCat)) {
    //         catName = " " + catName;
    //     }
    //     r[catName] = r[catName] || [];
    //     r[catName].push(a);
    //     return r;
    // }, Object.create(null));
  };

  changeRowsPerPage = (event) => {
    this.setState(
      {
        perPage: event.target.value,
        page: 1,
        startRecord: 1,
      },
      () => {
        this.myOfferings();
      },
    );
  };

  changePage = (e, page) => {
    this.setState(
      {
        page: page,
        startRecord: this.state.perPage * (page - 1) + 1,
      },
      () => {
        this.myOfferings();
      },
    );
  };

  filterProductsTable = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
      },
      () => {
        this.myOfferings();
      },
    );
  };

  clearProductsTableSearch = () => {
    this.setState(
      {
        productName: "",
        productCode: "",
        page: 1,
        startRecord: 1,
        selectedState: "all_offerings",
        selectedCategory: "all_offerings",
        formData: "",
        // allProductsProxy: [...this.state.allOriginalProducts]
      },
      () => {
        this.updateFilters();
        this.myOfferings();
        this.handleReset();
        // this.setState({
        //     allProducts: this.myOfferings()
        // })
      },
    );
  };

  handleReset = () => {
    // Toggle clearFilterTrigger state
    this.setState((prevState) => ({
      clearFilterTrigger: !prevState.clearFilterTrigger,
    }));
  };

  onChangeSearchFilter = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      // this.filterProductsTable();
      this.myOfferings();
    }
  };

  resetErrorMessage = () => {
    this.setState({
      productErrorMessage: "",
    });
  };
  getChannelsList = () => {
    BusApiCall("GET", `${constants.busV44Url}/getChannels`)
      .then((res) => {
        this.setState({
          channelList: res.data.channelList,
        });
      })
      .catch((err) => { });
  };
  getCategories = () => {
    BusApiCall(
      "GET",
      `${constants.busV4Url}/providers/${this.props.providerId}/menus`,
    )
      .then((res) => {
        this.setState({
          productCategoryList: res.data.menuCategories,
          categoryFilterList: res.data.menuFilteredByCategory,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        // this.setState({ loading: false })
      });
  };

  getStates = () => {
    var jsonData = {};
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_PRODUCT_STATES/endpoint`,
      jsonData,
    )
      .then((res) => {
        this.setState({
          stateFilterList: res.data,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
  };

  disableOtherPriceOption = (list) => {
    if (list && list.length > 0) {
      var tempList = [];
      var allOtherPricesList = [...this.state.allOtherPricesList];
      for (var i = 0; i < allOtherPricesList.length; i++) {
        let items = jp.query(
          list,
          '$..[?(@.priceType=="' + allOtherPricesList[i].value + '")]',
        );
        if (items.length > 0) {
          if (items.length === 1) {
            if (items[0].remove) {
              tempList.push(allOtherPricesList[i]);
            } else {
              tempList.push({ ...allOtherPricesList[i], disabled: true });
            }
          } else {
            tempList.push(allOtherPricesList[i]);
          }
        } else {
          tempList.push(allOtherPricesList[i]);
        }
      }
      this.setState({
        priceOptions: tempList,
      });
    } else {
      var tempList = [...this.state.allOtherPricesList];
      this.setState({
        priceOptions: tempList,
      });
    }
  };

  render() {
    const { t } = this.props;
    const mainStyle = {
      margin: "0",
      padding: "0",
      backgroundColor: "transparent",
    };
    const { classes: jssClasses } = this.props;

    return (
      <div className={"newContentWrapper"} style={{ marginBottom: "0px" }}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 4,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              <Grid
                item
                align="right"
                className={classes.buttonGroup}
                size={{
                  xs: 8,
                }}
              >
                {this.props.router.location.pathname === "/myOfferings" &&
                  this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                  this.props.loggedInUserType !== "ECOMMERCE_ADMIN" && 
                  (this.props.permissions.includes("CATALOG_ADMIN_ALL") ||
                  this.props.permissions.includes("CATALOG_CREATE") ||
                  this.props.permissions.includes("CATALOG_ADMIN")) && (
                    <>
                      <Button
                        className="buttonSecondary"
                        onClick={(e) => {
                          this.props.router.navigate("/productOfferingRules");
                        }}
                      >
                        {t("RULES")}
                      </Button>
                      {this.state.availableProductsLength > 0 &&
                        this.props.providerType === "SALES_CHNL_PROVIDER" &&
                        !this.props.tenantRoles.includes("CHILD_PROVIDER") && (
                          <Button
                            onClick={(e) => {
                              this.props.router.navigate("/availableOfferings");
                            }}
                          >
                            {t("AVAILABLE_SOLUTIONS")}
                          </Button>
                        )}
                      {(this.props.permissions.includes("CATALOG_ADMIN_ALL") ||
                        this.props.permissions.includes("CATALOG_CREATE") ||
                        this.props.permissions.includes("CATALOG_ADMIN")) && (
                          <>
                            {this.props.tenantRoles.includes("CHILD_PROVIDER") ? (
                              <>
                                {this.props.securityGroupsList.includes(
                                  "PRODUCT_MANAGER",
                                ) && (
                                    <Button
                                      onClick={(e) => {
                                        this.props.router.navigate(
                                          "/createPackage",
                                        );
                                      }}
                                    >
                                      <div
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <span
                                          style={{
                                            marginRight: "5px",
                                            position: "relative",
                                            top: ".1rem",
                                          }}
                                        >
                                          <PlusIcon />
                                        </span>
                                        <span>{t("NEW_SOLUTION")}</span>
                                      </div>
                                    </Button>
                                  )}
                              </>
                            ) : (
                              <Button
                                onClick={(e) => {
                                  this.props.router.navigate("/createPackage");
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  <span
                                    style={{
                                      marginRight: "5px",
                                      position: "relative",
                                      top: ".1rem",
                                    }}
                                  >
                                    <PlusIcon />
                                  </span>
                                  <span>{t("NEW_SOLUTION")}</span>
                                </div>
                              </Button>
                            )}
                          </>
                        )}
                    </>
                  )}
              </Grid>
            </Grid>
          </div>
        </div>
        <main style={{ position: "relative", marginBottom: "0px" }}>
          { }
          {/* <h3 className={'customBreadcrumb'}>
                    <label style={{ padding: '5px 0', fontWeight: '700' }}>
                        {this.props.router.location.pathname === "/myOfferings" ? 'My Solutions' : 'Available Solutions'}
                    </label>
                    <Select
                        onChange={(e) => { this.changeCategory(e) }}
                        options={this.state.categoryOptions}
                        selected={this.state.category}
                        name="category"
                        default={t('ALL_CATEGORIES')}
                        optionLabel={(option) => option.categoryName}
                        value={(option) => option.categoryId}
                        divClass={'customBreadcrumbSelect'}
                    />
                </h3> */}
          {/* Start: search filters */}
          {/* <div className={classes.filterDiv}>
                    <Select
                        onChange={(e) => {
                            this.setState({ partner: "" })
                            let index = this.state.categoryOptions.findIndex(a => a.categoryId === e.target.value);
                            this.props.selectCategory(index > -1 ? this.state.categoryOptions[index] : "")
                        }}
                        options={this.state.categoryOptions}
                        selected={this.props.category ? this.props.category.categoryId : ""}
                        name="category"
                        default="All Categories"
                        optionLabel={(option) => option.categoryName}
                        value={(option) => option.categoryId}
                    />
                    <Select
                        onChange={this.changePartner}
                        options={this.props.category ? this.props.category.partners : []}
                        selected={this.state.partner}
                        name="partner"
                        default="All Partners"
                        optionLabel={(option) => option.name}
                        value={(option) => option.id}
                    />
                </div> */}

          {/* End: search filters */}

          {/* <div className={'productPageFilters'}>
                    <Select
                        onChange={(e) => { this.changeCategory(e) }}
                        options={this.state.categoryOptions}
                        selected={this.state.category}
                        name="category"
                        default={t('ALL_CATEGORIES')}
                        optionLabel={(option) => option.categoryName}
                        value={(option) => option.categoryId}
                    />
                </div> */}

          {/* My solutions tab */}
          {this.props.router.location.pathname === "/myOfferings" &&
            this.state.childEnable && (
              <>
                <Grid
                  container
                  spacing={1}
                  style={{ alignItems: "center", marginBottom: "1rem" }}
                >
                  {this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" &&
                    this.props.loggedInUserType !== "ECOMMERCE_ADMIN" && (
                      <Grid
                        item
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                        size={{
                          xs: 6,
                          md: 9,
                        }}
                      >
                        <div className="text-caption"
                          style={{
                            margin: 0,
                            fontWeight: "normal",
                            float: "right",
                            paddingRight:
                              this.state.customerData.length > 0 &&
                                this.state.customerData[0].partyId
                                ? "50px"
                                : "35px",
                            paddingLeft: "10px",
                            position: "relative",
                            marginRight: "5px",
                          }}
                        >
                          {t("SHOW_FOR_CUSTOMER")}:&nbsp;
                          <span
                            style={{
                              fontWeight: "bold",
                              color: this.props.tenantData.color,
                              cursor: "pointer",
                            }}
                            onClick={() => this.changeCustomerCheck()}
                          >
                            {this.state.customerData.length > 0 &&
                              this.state.customerData[0].partyId ? (
                              <>
                                {this.state.customerData[0].accountName}
                                {this.state.customerData.length > 1 && (
                                  <Tooltip
                                    title={
                                      <React.Fragment
                                        style={{ whiteSpace: "pre" }}
                                      >
                                        {this.state.customerData.map(
                                          (item, index) =>
                                            index > 0 && (
                                              <div>{item.accountName}</div>
                                            ),
                                        )}
                                      </React.Fragment>
                                    }
                                  >
                                    <span>&nbsp;...</span>
                                  </Tooltip>
                                )}
                              </>
                            ) : (
                              "ALL"
                            )}
                            <Tooltip title={this.props.t("CHANGE")}>
                              <span
                                style={{
                                  fontSize: "20px",
                                  marginLeft: ".5rem",
                                  verticalAlign: "middle",
                                }}
                              >
                                <EditIconNew />
                              </span>
                            </Tooltip>
                          </span>
                          {this.state.customerData.length > 0 &&
                            this.state.customerData[0].partyId && (
                              <span
                                style={{
                                  cursor: "pointer",
                                  marginLeft: ".5rem",
                                  verticalAlign: "middle",
                                  position: "relative",
                                  top: ".2rem",
                                  color: this.props.tenantData.color,
                                }}
                              >
                                <Tooltip title={this.props.t("CLEAR")}>
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "20px",
                                        marginLeft: ".5rem",
                                        verticalAlign: "middle",
                                        color: this.props.tenantData.color,
                                      }}
                                      onClick={() => this.clearCustomerSelection()}
                                    >
                                        <ClearIcon />
                                    </span>
                                  </Tooltip>
                              </span>
                            )}
                        </div>
                      </Grid>
                    )}
                  <Grid
                    item
                    style={{ justifyContent: "flex-end", display: "flex" }}
                    size={{
                      xs: 6,
                      md: 3,
                    }}
                  >
                    <ButtonGroup variant="outlined">
                      {/* DETAIL VIEW button */}
                      <span
                        className={`buttonGroup ${this.state.viewMode === "Card" ? "selected" : ""}`}
                        onClick={this.toggleViewMode}
                        style={{
                          backgroundColor:
                            this.state.viewMode === "Card"
                              ? this.props.tenantData.color
                              : "inherit",
                          color:
                            this.state.viewMode === "Card"
                              ? "white"
                              : "inherit",
                        }}
                      >
                        <span style={{ marginRight: ".4rem" }}>
                          {this.props.t("CARD_VIEW")}
                        </span>
                        <DetailView />
                      </span>
                      {/* LIST VIEW button */}
                      <span
                        className={`buttonGroup ${this.state.viewMode === "Table" ? "selected" : ""}`}
                        onClick={this.toggleViewMode}
                        style={{
                          backgroundColor:
                            this.state.viewMode === "Table"
                              ? this.props.tenantData.color
                              : "inherit",
                          color:
                            this.state.viewMode === "Table"
                              ? "white"
                              : "inherit",
                        }}
                      >
                        <span>{this.props.t("LIST_VIEW")}</span>
                        <ListView />
                      </span>
                    </ButtonGroup>
                    {/* <span style={{ verticalAlign: 'sub', paddingRight: '10px' }}>
                                        <Tooltip title={t('CARD_VIEW')}>
                                            <span style={{ color: this.state.viewMode === 'Card' ? this.props.tenantData.color : 'grey', padding: '3px 0px' }}>
                                                <svg width="28" height="24" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={this.toggleViewMode}>
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M3.50016 1.33399C3.50724 1.33399 3.51433 1.33399 3.52142 1.33399H6.05476C6.06185 1.33399 6.06894 1.33399 6.07602 1.33399C6.24428 1.33397 6.40814 1.33395 6.54691 1.34528C6.6993 1.35774 6.87913 1.38711 7.06008 1.47931C7.31096 1.60714 7.51493 1.81112 7.64276 2.062C7.73496 2.24295 7.76434 2.42277 7.77679 2.57517C7.78813 2.71394 7.78811 2.87781 7.78809 3.04607V5.62191C7.78811 5.79017 7.78813 5.95403 7.77679 6.09281C7.76434 6.2452 7.73496 6.42503 7.64276 6.60598C7.51493 6.85686 7.31096 7.06083 7.06008 7.18866C6.87913 7.28086 6.6993 7.31024 6.54691 7.32269C6.40813 7.33403 6.24427 7.33401 6.07601 7.33399H3.50017C3.33191 7.33401 3.16804 7.33403 3.02927 7.32269C2.87687 7.31024 2.69705 7.28086 2.5161 7.18866C2.26522 7.06083 2.06125 6.85686 1.93341 6.60598C1.84122 6.42503 1.81184 6.2452 1.79939 6.09281C1.78805 5.95404 1.78807 5.79017 1.78809 5.62192C1.78809 5.61484 1.78809 5.60775 1.78809 5.60065V3.06732C1.78809 3.06023 1.78809 3.05314 1.78809 3.04606C1.78807 2.8778 1.78805 2.71394 1.79939 2.57517C1.81184 2.42277 1.84122 2.24295 1.93341 2.062C2.06125 1.81112 2.26522 1.60714 2.5161 1.47931C2.69705 1.38711 2.87687 1.35774 3.02927 1.34528C3.16804 1.33395 3.3319 1.33397 3.50016 1.33399ZM3.12905 2.67495C3.1288 2.67772 3.12854 2.68065 3.12829 2.68374C3.12194 2.76147 3.12142 2.86964 3.12142 3.06732V5.60065C3.12142 5.79834 3.12194 5.90651 3.12829 5.98423C3.12854 5.98733 3.1288 5.99025 3.12905 5.99302C3.13182 5.99328 3.13475 5.99353 3.13785 5.99379C3.21557 6.00014 3.32374 6.00065 3.52142 6.00065H6.05476C6.25244 6.00065 6.36061 6.00014 6.43833 5.99379C6.44143 5.99353 6.44436 5.99328 6.44712 5.99302C6.44738 5.99025 6.44763 5.98733 6.44789 5.98423C6.45424 5.90651 6.45476 5.79834 6.45476 5.60065V3.06732C6.45476 2.86964 6.45424 2.76147 6.44789 2.68374C6.44763 2.68065 6.44738 2.67772 6.44712 2.67495C6.44436 2.6747 6.44143 2.67444 6.43833 2.67419C6.36061 2.66784 6.25244 2.66732 6.05476 2.66732H3.52142C3.32374 2.66732 3.21557 2.66784 3.13785 2.67419C3.13475 2.67444 3.13182 2.6747 3.12905 2.67495ZM10.8335 1.33399H13.4094C13.5776 1.33397 13.7415 1.33395 13.8802 1.34528C14.0326 1.35774 14.2125 1.38711 14.3934 1.47931C14.6443 1.60714 14.8483 1.81112 14.9761 2.062C15.0683 2.24295 15.0977 2.42277 15.1101 2.57517C15.1215 2.71394 15.1214 2.87779 15.1214 3.04604V5.62193C15.1214 5.79018 15.1215 5.95404 15.1101 6.09281C15.0977 6.2452 15.0683 6.42503 14.9761 6.60598C14.8483 6.85686 14.6443 7.06083 14.3934 7.18866C14.2125 7.28086 14.0326 7.31024 13.8802 7.32269C13.7415 7.33403 13.5776 7.33401 13.4093 7.33399H10.8335C10.6652 7.33401 10.5014 7.33403 10.3626 7.32269C10.2102 7.31024 10.0304 7.28086 9.84943 7.18866C9.59855 7.06083 9.39458 6.85686 9.26675 6.60598C9.17455 6.42503 9.14517 6.2452 9.13272 6.09281C9.12138 5.95403 9.1214 5.79017 9.12142 5.62191V3.04607C9.1214 2.87781 9.12138 2.71394 9.13272 2.57517C9.14517 2.42277 9.17455 2.24295 9.26675 2.062C9.39458 1.81112 9.59855 1.60714 9.84943 1.47931C10.0304 1.38711 10.2102 1.35774 10.3626 1.34528C10.5014 1.33395 10.6652 1.33397 10.8335 1.33399ZM10.4624 2.67495C10.4621 2.67772 10.4619 2.68065 10.4616 2.68374C10.4553 2.76147 10.4548 2.86964 10.4548 3.06732V5.60065C10.4548 5.79834 10.4553 5.90651 10.4616 5.98423C10.4619 5.98733 10.4621 5.99025 10.4624 5.99302C10.4652 5.99328 10.4681 5.99353 10.4712 5.99379C10.5489 6.00014 10.6571 6.00065 10.8548 6.00065H13.3881C13.5858 6.00065 13.6939 6.00014 13.7717 5.99379C13.7748 5.99353 13.7777 5.99327 13.7805 5.99302C13.7807 5.99025 13.781 5.98732 13.7812 5.98423C13.7876 5.90651 13.7881 5.79834 13.7881 5.60065V3.06732C13.7881 2.86964 13.7876 2.76147 13.7812 2.68374C13.781 2.68065 13.7807 2.67772 13.7805 2.67495C13.7777 2.6747 13.7748 2.67444 13.7717 2.67419C13.6939 2.66784 13.5858 2.66732 13.3881 2.66732H10.8548C10.6571 2.66732 10.5489 2.66784 10.4712 2.67419C10.4681 2.67444 10.4652 2.6747 10.4624 2.67495ZM3.50017 8.66732H6.07601C6.24427 8.6673 6.40813 8.66728 6.54691 8.67862C6.6993 8.69107 6.87913 8.72045 7.06008 8.81264C7.31096 8.94048 7.51493 9.14445 7.64276 9.39533C7.73496 9.57628 7.76434 9.7561 7.77679 9.9085C7.78813 10.0473 7.78811 10.2111 7.78809 10.3794V12.9552C7.78811 13.1235 7.78813 13.2874 7.77679 13.4261C7.76434 13.5785 7.73496 13.7584 7.64276 13.9393C7.51493 14.1902 7.31096 14.3942 7.06008 14.522C6.87913 14.6142 6.6993 14.6436 6.54691 14.656C6.40814 14.6674 6.24428 14.6673 6.07603 14.6673H3.50015C3.33189 14.6673 3.16804 14.6674 3.02927 14.656C2.87687 14.6436 2.69705 14.6142 2.5161 14.522C2.26522 14.3942 2.06125 14.1902 1.93341 13.9393C1.84122 13.7584 1.81184 13.5785 1.79939 13.4261C1.78805 13.2874 1.78807 13.1235 1.78809 12.9553V10.3794C1.78807 10.2111 1.78805 10.0473 1.79939 9.9085C1.81184 9.7561 1.84122 9.57628 1.93341 9.39533C2.06125 9.14445 2.26522 8.94048 2.5161 8.81264C2.69705 8.72045 2.87687 8.69107 3.02927 8.67862C3.16804 8.66728 3.33191 8.6673 3.50017 8.66732ZM3.12905 10.0083C3.1288 10.0111 3.12854 10.014 3.12829 10.0171C3.12194 10.0948 3.12142 10.203 3.12142 10.4007V12.934C3.12142 13.1317 3.12194 13.2398 3.12829 13.3176C3.12854 13.3207 3.1288 13.3236 3.12905 13.3263C3.13182 13.3266 3.13475 13.3269 3.13785 13.3271C3.21557 13.3335 3.32374 13.334 3.52142 13.334H6.05476C6.25244 13.334 6.36061 13.3335 6.43833 13.3271C6.44143 13.3269 6.44436 13.3266 6.44712 13.3263C6.44738 13.3236 6.44763 13.3207 6.44789 13.3176C6.45424 13.2398 6.45476 13.1317 6.45476 12.934V10.4007C6.45476 10.203 6.45424 10.0948 6.44789 10.0171C6.44763 10.014 6.44738 10.0111 6.44712 10.0083C6.44436 10.008 6.44143 10.0078 6.43833 10.0075C6.36061 10.0012 6.25244 10.0007 6.05476 10.0007H3.52142C3.32374 10.0007 3.21557 10.0012 3.13785 10.0075C3.13475 10.0078 3.13182 10.008 3.12905 10.0083ZM10.8335 8.66732H13.4093C13.5776 8.6673 13.7415 8.66728 13.8802 8.67862C14.0326 8.69107 14.2125 8.72045 14.3934 8.81264C14.6443 8.94048 14.8483 9.14445 14.9761 9.39533C15.0683 9.57628 15.0977 9.7561 15.1101 9.9085C15.1215 10.0473 15.1214 10.2111 15.1214 10.3794V12.9553C15.1214 13.1235 15.1215 13.2874 15.1101 13.4261C15.0977 13.5785 15.0683 13.7584 14.9761 13.9393C14.8483 14.1902 14.6443 14.3942 14.3934 14.522C14.2125 14.6142 14.0326 14.6436 13.8802 14.656C13.7415 14.6674 13.5776 14.6673 13.4094 14.6673H10.8335C10.6652 14.6673 10.5014 14.6674 10.3626 14.656C10.2102 14.6436 10.0304 14.6142 9.84943 14.522C9.59855 14.3942 9.39458 14.1902 9.26675 13.9393C9.17455 13.7584 9.14517 13.5785 9.13272 13.4261C9.12138 13.2874 9.1214 13.1235 9.12142 12.9552V10.3794C9.1214 10.2111 9.12138 10.0473 9.13272 9.9085C9.14517 9.7561 9.17455 9.57628 9.26675 9.39533C9.39458 9.14445 9.59855 8.94048 9.84943 8.81264C10.0304 8.72045 10.2102 8.69107 10.3626 8.67862C10.5014 8.66728 10.6652 8.6673 10.8335 8.66732ZM10.4624 10.0083C10.4621 10.0111 10.4619 10.014 10.4616 10.0171C10.4553 10.0948 10.4548 10.203 10.4548 10.4007V12.934C10.4548 13.1317 10.4553 13.2398 10.4616 13.3176C10.4619 13.3207 10.4621 13.3236 10.4624 13.3263C10.4652 13.3266 10.4681 13.3269 10.4712 13.3271C10.5489 13.3335 10.6571 13.334 10.8548 13.334H13.3881C13.5858 13.334 13.6939 13.3335 13.7717 13.3271C13.7748 13.3269 13.7777 13.3266 13.7805 13.3263C13.7807 13.3236 13.781 13.3207 13.7812 13.3176C13.7876 13.2398 13.7881 13.1317 13.7881 12.934V10.4007C13.7881 10.203 13.7876 10.0948 13.7812 10.0171C13.781 10.014 13.7807 10.0111 13.7805 10.0083C13.7777 10.008 13.7748 10.0078 13.7717 10.0075C13.6939 10.0012 13.5858 10.0007 13.3881 10.0007H10.8548C10.6571 10.0007 10.5489 10.0012 10.4712 10.0075C10.4681 10.0078 10.4652 10.008 10.4624 10.0083Z" fill="currentColor" />
                                                </svg>
                                            </span>
                                        </Tooltip>

                                        <Tooltip title={t('TABLE_VIEW')}>
                                            <span style={{ color: this.state.viewMode === 'Table' ? this.props.tenantData.color : 'grey', padding: '3px 0px' }}>
                                                <svg width="28" height="24" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={this.toggleViewMode}>
                                                    <path fillRule="evenodd" clipRule="evenodd" d="M4.56239 1.33398L12.3471 1.33399C12.6985 1.33397 13.0017 1.33396 13.2514 1.35437C13.515 1.3759 13.7771 1.42344 14.0294 1.55197C14.4057 1.74372 14.7117 2.04968 14.9034 2.42601C15.032 2.67826 15.0795 2.9404 15.101 3.20397C15.1214 3.45368 15.1214 3.75685 15.1214 4.10827V4.5597C15.1214 4.91112 15.1214 5.21429 15.101 5.464C15.0795 5.72757 15.032 5.98971 14.9034 6.24197C14.7117 6.61829 14.4057 6.92425 14.0294 7.116C13.7771 7.24453 13.515 7.29207 13.2514 7.31361C13.0017 7.33401 12.6985 7.334 12.3471 7.33399H4.56241C4.21097 7.334 3.90779 7.33401 3.65807 7.31361C3.39451 7.29207 3.13236 7.24453 2.88011 7.116C2.50378 6.92425 2.19782 6.61829 2.00607 6.24197C1.87754 5.98971 1.83 5.72757 1.80847 5.464C1.78806 5.21429 1.78807 4.91111 1.78809 4.55968V4.10829C1.78807 3.75686 1.78806 3.45368 1.80847 3.20397C1.83 2.9404 1.87754 2.67826 2.00607 2.426C2.19782 2.04968 2.50378 1.74372 2.88011 1.55197C3.13236 1.42344 3.39451 1.3759 3.65807 1.35437C3.90778 1.33396 4.21096 1.33397 4.56239 1.33398ZM3.76664 2.68327C3.58554 2.69807 3.51839 2.72319 3.48543 2.73998C3.35999 2.8039 3.258 2.90588 3.19408 3.03133C3.17729 3.06429 3.15217 3.13143 3.13737 3.31254C3.12194 3.50143 3.12142 3.74962 3.12142 4.13399V4.53399C3.12142 4.91835 3.12194 5.16654 3.13737 5.35543C3.15217 5.53654 3.17729 5.60368 3.19408 5.63665C3.258 5.76209 3.35999 5.86407 3.48543 5.92799C3.51839 5.94479 3.58554 5.9699 3.76664 5.9847C3.95554 6.00013 4.20372 6.00065 4.58809 6.00065L12.3214 6.00065C12.7058 6.00065 12.954 6.00013 13.1429 5.9847C13.324 5.9699 13.3911 5.94479 13.4241 5.92799C13.5495 5.86407 13.6515 5.76209 13.7154 5.63665C13.7322 5.60368 13.7573 5.53654 13.7721 5.35543C13.7876 5.16654 13.7881 4.91835 13.7881 4.53399V4.13399C13.7881 3.74962 13.7876 3.50143 13.7721 3.31254C13.7573 3.13143 13.7322 3.06429 13.7154 3.03133C13.6515 2.90588 13.5495 2.8039 13.4241 2.73998C13.3911 2.72319 13.324 2.69807 13.1429 2.68327C12.954 2.66784 12.7058 2.66732 12.3214 2.66732L4.58809 2.66732C4.20372 2.66732 3.95554 2.66784 3.76664 2.68327ZM4.56241 8.66732L12.3471 8.66732C12.6985 8.66731 13.0017 8.6673 13.2514 8.6877C13.515 8.70923 13.7771 8.75678 14.0294 8.88531C14.4057 9.07705 14.7117 9.38301 14.9034 9.75934C15.032 10.0116 15.0795 10.2737 15.101 10.5373C15.1214 10.787 15.1214 11.0902 15.1214 11.4416V11.893C15.1214 12.2445 15.1214 12.5476 15.101 12.7973C15.0795 13.0609 15.032 13.323 14.9034 13.5753C14.7117 13.9516 14.4057 14.2576 14.0294 14.4493C13.7771 14.5779 13.515 14.6254 13.2514 14.6469C13.0017 14.6673 12.6986 14.6673 12.3471 14.6673H4.56238C4.21095 14.6673 3.90778 14.6673 3.65807 14.6469C3.39451 14.6254 3.13236 14.5779 2.88011 14.4493C2.50378 14.2576 2.19782 13.9516 2.00607 13.5753C1.87754 13.323 1.83 13.0609 1.80847 12.7973C1.78806 12.5476 1.78807 12.2444 1.78809 11.893V11.4416C1.78807 11.0902 1.78806 10.787 1.80847 10.5373C1.83 10.2737 1.87754 10.0116 2.00607 9.75934C2.19782 9.38301 2.50378 9.07705 2.88011 8.88531C3.13236 8.75678 3.39451 8.70923 3.65807 8.6877C3.90779 8.6673 4.21097 8.66731 4.56241 8.66732ZM3.76664 10.0166C3.58554 10.0314 3.51839 10.0565 3.48543 10.0733C3.35999 10.1372 3.258 10.2392 3.19408 10.3647C3.17729 10.3976 3.15217 10.4648 3.13737 10.6459C3.12194 10.8348 3.12142 11.083 3.12142 11.4673V11.8673C3.12142 12.2517 3.12194 12.4999 3.13737 12.6888C3.15217 12.8699 3.17729 12.937 3.19408 12.97C3.258 13.0954 3.35999 13.1974 3.48543 13.2613C3.51839 13.2781 3.58554 13.3032 3.76664 13.318C3.95554 13.3335 4.20372 13.334 4.58809 13.334H12.3214C12.7058 13.334 12.954 13.3335 13.1429 13.318C13.324 13.3032 13.3911 13.2781 13.4241 13.2613C13.5495 13.1974 13.6515 13.0954 13.7154 12.97C13.7322 12.937 13.7573 12.8699 13.7721 12.6888C13.7876 12.4999 13.7881 12.2517 13.7881 11.8673V11.4673C13.7881 11.083 13.7876 10.8348 13.7721 10.6459C13.7573 10.4648 13.7322 10.3976 13.7154 10.3647C13.6515 10.2392 13.5495 10.1372 13.4241 10.0733C13.3911 10.0565 13.324 10.0314 13.1429 10.0166C12.954 10.0012 12.7058 10.0007 12.3214 10.0007H4.58809C4.20372 10.0007 3.95554 10.0012 3.76664 10.0166Z" fill="currentColor" />
                                                </svg>
                                            </span>
                                        </Tooltip>
                                    </span> */}
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  style={{
                    marginLeft: 0,
                    marginRight: 0,
                    width: "100%",
                    justifyContent: "flex-end",
                  }}
                >
                  {/* {(this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" && this.props.loggedInUserType !== "ECOMMERCE_ADMIN") &&
                                    <Grid item xs={12} md={3}>
                                        <h3 style={{ margin: 0, fontWeight: 'normal', float: 'right', lineHeight: '29px', paddingRight: (this.state.customerData.length > 0 && this.state.customerData[0].partyId) ? '50px' : '35px', paddingLeft: '10px', position: 'relative', marginRight: '5px' }}>
                                            {t('SELECTED_CUSTOMER')}:&nbsp;
                                            <span style={{ fontWeight: 'bold', color: this.props.tenantData.color, cursor: 'pointer' }} onClick={() => this.changeCustomerCheck()}>
                                                {(this.state.customerData.length > 0 && this.state.customerData[0].partyId) ?
                                                    <>
                                                        {this.state.customerData[0].accountName}
                                                        {this.state.customerData.length > 1 &&
                                                            <Tooltip title={
                                                                <React.Fragment style={{ whiteSpace: 'pre' }}>
                                                                    {this.state.customerData.map((item, index) => (
                                                                        index > 0 &&
                                                                        <div>
                                                                            {item.accountName}
                                                                        </div>
                                                                    )
                                                                    )}

                                                                </React.Fragment>
                                                            }><span>&nbsp;...</span></Tooltip>
                                                        }
                                                    </>
                                                    :
                                                    'ALL'
                                                }
                                                <Tooltip title={this.props.t('CHANGE')}>
                                                    <span style={{ fontSize: '20px', marginLeft: '.5rem', verticalAlign: 'middle' }}>
                                                        <EditIconNew />
                                                    </span>
                                                </Tooltip>
                                            </span>
                                            {(this.state.customerData.length > 0 && this.state.customerData[0].partyId) &&
                                                <span style={{ cursor: 'pointer', marginLeft: '.5rem', verticalAlign: 'middle', color: this.props.tenantData.color }}>
                                                    <Tooltip title={this.props.t('CLEAR')}>
                                                        <ClearIconMUI onClick={() => this.clearCustomerSelection()} />
                                                    </Tooltip>
                                                </span>
                                            }
                                        </h3>
                                    </Grid>
                                } */}
                  <Grid
                    item
                    size={{
                      xs: 6,
                      md: 2,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      placeholder={t("SEARCH_BY_OFFERING_NAME")}
                      value={this.state.productName}
                      name={"productName"}
                      onChange={(e) => {
                        this.onChangeSearchFilter(e);
                      }}
                      divClass={classes.inputClass}
                      onKeyDown={(e) => {
                        this.onSearchKeyDown(e);
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 6,
                      md: 2,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      placeholder={t("SEARCH_BY_OFFERING_CODE")}
                      value={this.state.productCode}
                      name={"productCode"}
                      onChange={(e) => {
                        this.onChangeSearchFilter(e);
                      }}
                      divClass={classes.inputClass}
                      onKeyDown={(e) => {
                        this.onSearchKeyDown(e);
                      }}
                    />
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 6,
                      md: 2,
                    }}
                  >
                    <FormControl variant="outlined" size={"small"}>
                      <InputLabel
                        id="selectedCategory"
                        htmlFor="outlined-age-native-simple"
                      >
                        {" "}
                        {t("SEARCH_BY_CATEGORY")}
                      </InputLabel>
                      <Select
                        labelId="selectedCategory"
                        label="Search by Category"
                        native
                        size={"small"}
                        variant={"outlined"}
                        name={"selectedCategory"}
                        inputProps={{
                          name: "selectedCategory",
                          id: "outlined-native-selectedCategory",
                        }}
                        value={this.state.selectedCategory}
                        onChange={(e) => {
                          this.onChangeSearchFilter(e);
                        }}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                      >
                        <option value={"all_offerings"} selected>
                          {t("ALL")}
                        </option>
                        {this.state.categoryFilterList.map((a) => (
                          <option key={a.categoryId} value={a.categoryId}>
                            {a.categoryName}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid
                    item
                    size={{
                      xs: 6,
                      md: 2,
                    }}
                  >
                    <FormControl variant="outlined" size={"small"}>
                      <InputLabel
                        id="selectedState"
                        htmlFor="outlined-age-native-simple"
                      >
                        {" "}
                        {t("SEARCH_BY_STATE")}
                      </InputLabel>
                      <Select
                        labelId="selectedState"
                        label="Search by State"
                        native
                        size={"small"}
                        variant={"outlined"}
                        name={"selectedState"}
                        inputProps={{
                          name: "selectedState",
                          id: "outlined-native-selectedState",
                        }}
                        value={this.state.selectedState}
                        onChange={(e) => {
                          this.onChangeSearchFilter(e);
                        }}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                      >
                        <option value={"all_offerings"} selected>
                          {t("ALL")}
                        </option>
                        {this.state.stateFilterList.map((a) => (
                          <option key={a.id} value={a.id}>
                            {a.name}
                          </option>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid
                    item
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      minWidth: "7rem",
                      maxWidth: "7%",
                    }}
                    size={{
                      xs: 6,
                      md: 1,
                    }}
                  >
                    <Tooltip title={t("SEARCH")}>
                      <IconButton
                        className="iconButtonSecondary"
                        onClick={this.filterProductsTable}
                      >
                        <SearchIcon />
                      </IconButton>
                    </Tooltip>{" "}
                    &nbsp;
                    <Tooltip title={t("CLEAR")}>
                      <IconButton
                        className="iconButtonSecondary"
                        onClick={this.clearProductsTableSearch}
                      >
                        <ClearIcon />
                      </IconButton>
                    </Tooltip>
                    &nbsp;
                    {this.state.customAttributesList.length > 0 && (
                      // <button onClick={this.toggleChildVisibility}>
                      //     {this.state.showChild ? 'Hide Filters' : 'Show Filters'}
                      // </button>
                      <Tooltip title={t("Advance Filters")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={this.toggleChildVisibility}
                        >
                          <AdvanceSearchIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={1}
                  justifyContent="flex-end"
                  style={{
                    borderTop: this.state.showChild
                      ? ".5px solid lightgrey"
                      : "none",
                    marginLeft: 0,
                    marginRight: 0,
                    width: "100%",
                    justifyContent: "flex-end",
                    marginTop: "1rem",
                    paddingTop: ".5rem",
                  }}
                >
                  {this.state.showChild && (
                    <>
                      <CustomAttributeSearch
                        customAttributesList={this.state.customAttributesList}
                        t={t}
                        valueTakenFromChild={this.handleChildStateChange}
                        clearFilterTrigger={this.state.clearFilterTrigger}
                      />
                    </>
                  )}
                </Grid>

                {this.state.viewMode === "Card" && (
                  <>
                    {Object.keys(this.state.groupedProducts)
                      .sort()
                      .map((key, i) => (
                        <Grid
                          container
                          spacing={4}
                          key={i}
                          style={{
                            marginLeft: 0,
                            marginRight: 0,
                            width: "100%",
                            marginBottom: "40px",
                          }}
                        >
                          <Grid
                            item
                            size={{
                              xs: 12,
                            }}
                          >
                            <h4 className={"viewProductCategoryNew"}>{key}</h4>
                          </Grid>
                          {this.state.groupedProducts[key]
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((product, index) => (
                              // Prodcut display card
                              // !product.isApproved && //display only those solutions which are not approved
                              // <ProductCard
                              //     key={index}
                              //     product={product}
                              //     productIndex={index}
                              //     solutionAction={this.props.router.location.pathname}
                              //     removeProduct={this.removeProduct}
                              //     providerType={this.props.providerType}
                              //     editStandaloneProduct={this.editStandaloneProduct}
                              //     offeringCustomer={this.state.customerData.length > 0 ? this.state.customerData[0].partyId : ''}
                              //     availableCustomers={(this.props.loggedInUserType == "ECOMMERCE_CUSTOMER" || this.props.loggedInUserType === "ECOMMERCE_ADMIN") ? [] : (product.customer && product.customer.length > 0 ? product.customer : [])}
                              // />
                              <ProductCardNew
                                key={index}
                                product={product}
                                productIndex={index}
                                solutionAction={
                                  this.props.router.location.pathname
                                }
                                removeProduct={this.removeProduct}
                                providerType={this.props.providerType}
                                editStandaloneProduct={
                                  this.editStandaloneProduct
                                }
                                offeringCustomer={
                                  this.state.customerData.length > 0
                                    ? this.state.customerData[0].partyId
                                    : ""
                                }
                                availableCustomers={
                                  this.props.loggedInUserType ==
                                    "ECOMMERCE_CUSTOMER" ||
                                    this.props.loggedInUserType ===
                                    "ECOMMERCE_ADMIN"
                                    ? []
                                    : product.customer &&
                                      product.customer.length > 0
                                      ? product.customer
                                      : []
                                }
                                setErrorMessage={this.props.setErrorMessage}
                              />
                            ))}
                        </Grid>
                      ))}
                    {this.state.allProductsProxy.length > 0 && (
                      <div
                        className="global-custom-pagination"
                        style={{ background: "rgba(196, 196, 196, 0.2)" }}
                      >
                        <label style={{ float: "left", padding: "5px" }}>
                          {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalCount)}
                        </label>
                        <label>
                          {/* Rows per page select */}
                          {t("ROWS_PER_PAGE")}
                          <Select
                            value={this.state.perPage}
                            onChange={this.changeRowsPerPage}
                          >
                            <MenuItem
                              value={10}
                              classes={{ root: "treeRowPerPageItem" }}
                            >
                              10
                            </MenuItem>
                            <MenuItem
                              value={50}
                              classes={{ root: "treeRowPerPageItem" }}
                            >
                              50
                            </MenuItem>
                            <MenuItem
                              value={100}
                              classes={{ root: "treeRowPerPageItem" }}
                            >
                              100
                            </MenuItem>
                          </Select>
                        </label>
                        {/* Pagination component */}
                        <Pagination
                          page={this.state.page}
                          count={Math.ceil(
                            this.state.totalCount / this.state.perPage,
                          )}
                          onChange={this.changePage}
                          showFirstButton
                          showLastButton
                        />
                      </div>
                    )}
                  </>
                )}

                {this.state.viewMode === "Table" && (
                  <>
                    {Object.keys(this.state.groupedProducts).length > 0 && (
                      // <Paper className="tablePaper" style={{ padding: '12px', borderRadius: '8px' }} >
                      <Card
                        variant="outlined"
                        style={{ borderRadius: "8px", marginTop: "1rem" }}
                      >
                        <TableContainer>
                          <Table className={"newGlobalTable"}>
                            <TableHead>
                              <TableRow>
                                <TableCell>{t("OFFERING_CODE")}</TableCell>
                                <TableCell style={{ width: "14rem" }}>
                                  {t("OFFERING_NAME")}
                                </TableCell>
                                <TableCell>{t("DESCRIPTION")}</TableCell>
                                <TableCell>{t("CATEGORY")}</TableCell>
                                <TableCell>{t("STATUS")}</TableCell>
                                <TableCell>{t("PRICE")}</TableCell>
                                {/* <TableCell>
                                                                {(this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" && this.props.loggedInUserType !== "ECOMMERCE_ADMIN") &&
                                                                    t('ACTIONS')
                                                                }
                                                            </TableCell> */}
                                <TableCell
                                  colSpan={2}
                                  style={{ textAlign: "end" }}
                                >
                                  {t("ACTIONS")}
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {/* {this.state.allProducts.map((product, index) =>
                                                        <ProductTable
                                                            key={index}
                                                            product={product}
                                                            productIndex={index}
                                                            solutionAction={this.props.router.location.pathname}
                                                            removeProduct={this.removeProduct}
                                                            providerType={this.props.providerType}
                                                            editStandaloneProduct={this.editStandaloneProduct}
                                                        />
                                                    )} */}
                              {Object.keys(this.state.groupedProducts)
                                .sort()
                                .map((key, i) => (
                                  <React.Fragment key={i}>
                                    {this.state.groupedProducts[key]
                                      .sort((a, b) =>
                                        a.name.localeCompare(b.name),
                                      )
                                      .map((product, index) => (
                                        <ProductTable
                                          key={index}
                                          product={product}
                                          productIndex={index}
                                          solutionAction={
                                            this.props.router.location.pathname
                                          }
                                          removeProduct={this.removeProduct}
                                          providerType={this.props.providerType}
                                          editStandaloneProduct={
                                            this.editStandaloneProduct
                                          }
                                          productCategory={key}
                                          offeringCustomer={
                                            this.state.customerData.length > 0
                                              ? this.state.customerData[0]
                                                .partyId
                                              : ""
                                          }
                                          availableCustomers={
                                            this.props.loggedInUserType ==
                                              "ECOMMERCE_CUSTOMER" ||
                                              this.props.loggedInUserType ===
                                              "ECOMMERCE_ADMIN"
                                              ? []
                                              : product.customer &&
                                                product.customer.length > 0
                                                ? product.customer
                                                : []
                                          }
                                          setErrorMessage={
                                            this.props.setErrorMessage
                                          }
                                        />
                                      ))}
                                  </React.Fragment>
                                ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        {this.state.totalCount > 0 && (
                          <div
                            className="global-custom-pagination"
                            style={{ background: "rgba(196, 196, 196, 0.2)" }}
                          >
                            <label style={{ float: "left", padding: "5px" }}>
                              {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalCount)}
                            </label>
                            <label>
                              {/* Rows per page select */}
                              {t("ROWS_PER_PAGE")}
                              <Select
                                value={this.state.perPage}
                                onChange={this.changeRowsPerPage}
                              >
                                <MenuItem
                                  value={10}
                                  classes={{ root: "treeRowPerPageItem" }}
                                >
                                  10
                                </MenuItem>
                                <MenuItem
                                  value={50}
                                  classes={{ root: "treeRowPerPageItem" }}
                                >
                                  50
                                </MenuItem>
                                <MenuItem
                                  value={100}
                                  classes={{ root: "treeRowPerPageItem" }}
                                >
                                  100
                                </MenuItem>
                              </Select>
                            </label>
                            {/* Pagination component */}
                            <Pagination
                              page={this.state.page}
                              count={Math.ceil(
                                this.state.totalCount / this.state.perPage,
                              )}
                              onChange={this.changePage}
                              showFirstButton
                              showLastButton
                            />
                          </div>
                        )}
                        {/* </Paper> */}
                      </Card>
                    )}
                  </>
                )}

                {/* No packaged solution avaiable message */}
                {this.state.totalCount === 0 &&
                  this.state.displayAvailableMsg && (
                    <Grid
                      container
                      spacing={2}
                      justifyContent="center"
                      style={{ marginTop: "2rem", alignItems: "center" }}
                    >
                      <Grid
                        item
                        align="center"
                        size={{
                          xs: 12,
                        }}
                      >
                        {/* <h4 style={{ color: this.props.tenantData.color, margin: 0, fontSize: '20px', marginTop: '60px' }} align="center"> */}
                        {/* <h4 style={{ margin: 0, fontSize: '1rem'}} align="center"> */}
                        <span className="text-body">
                          {/* {this.state.products.length === 0 ?
                                                t('EMPTY_SOLUTION_CATALOG')
                                                :
                                                this.state.totalCount === 0 ?
                                                    t('NO_OFFERING_FOUND')
                                                    :
                                                    ''
                                            } */}
                          {this.state.totalCount === 0 &&
                            t("NO_OFFERING_FOUND")}
                        </span>
                        {/* </h4> */}
                      </Grid>
                    </Grid>
                  )}
              </>
            )}

          {/* Available solutions tab */}
          {this.props.router.location.pathname === "/availableOfferings" && (
            <>
              {Object.keys(this.state.groupedProducts).map((key, i) => (
                <Grid
                  container
                  spacing={4}
                  key={i}
                  style={{
                    marginLeft: 0,
                    marginRight: 0,
                    width: "100%",
                    marginBottom: "40px",
                  }}
                >
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <h4
                      className={"viewProductCategoryNew"}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      {key}
                      <Button
                        onClick={() =>
                          this.viewContracts(
                            this.state.groupedProducts[key][0].vendorPartyId,
                            key,
                          )
                        }
                      >
                        {t("CONTRACTS")}
                      </Button>
                    </h4>
                  </Grid>
                  {this.state.groupedProducts[key]
                    .sort((a, b) => a.productName.localeCompare(b.productName))
                    .map((product, index) => (
                      // Prodcu display card
                      <ProductCardNew
                        key={index}
                        product={product}
                        solutionAction={this.props.router.location.pathname}
                        providerType={this.props.providerType}
                        editStandaloneProduct={this.editStandaloneProduct}
                        setErrorMessage={this.props.setErrorMessage}
                      />
                    ))}
                </Grid>
              ))}
              {/* No packaged solution avaiable message */}
              {this.state.products.length === 0 &&
                this.state.displayAvailableMsg && (
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    <h4
                      style={{
                        color: this.props.tenantData.color,
                        margin: 0,
                        fontSize: "20px",
                      }}
                      align="center"
                    >
                      {t("EMPTY_AVAILABLE_SOLUTION_CATALOG")}
                    </h4>
                  </Grid>
                )}
            </>
          )}
          {this.state.showCustomerDialog && (
            <Dialog
              disableScrollLock={true}
              maxWidth={"sm"}
              PaperComponent={this.draggableDialogPaper}
              fullWidth={true}
              open={this.state.showCustomerDialog}
              aria-labelledby="import-dialog-title"
              PaperProps={
                {
                  // className: jssClasses.resizablePaper
                }
              }
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                <div style={{ display: "flex" }}>
                  <span style={{ display: "inline-flex", width: "95%" }}>
                    {this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                      this.props.loggedInUserType === "ECOMMERCE_ADMIN"
                      ? t("SELECT_SHIPPING_ADDRESS")
                      : t("SELECT_CUSTOMER")}
                  </span>
                  <Tooltip title={t("CLOSE")}>
                    <IconButton
                      onTouchStart={(event) => this.closeChangeCustomer(false)}
                      onClick={(event) => this.closeChangeCustomer(false)}
                      aria-label="close"
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </DialogTitle>
              <DialogContent dividers style={{ height: "500px" }}>
                <ManageCustomersHierarchy
                  // screen="createOffering"
                  // subScreen="productsFilter"
                  screen="products"
                  subScreen="productsFilter"
                  selectCustomers={this.selectCustomers}
                  customerData={this.state.customerDataProxy}
                />
              </DialogContent>
              <DialogActions>
                {/* <Button onClick={event => this.closeChangeCustomer(false)} color="primary">{t('CANCEL')}</Button> */}
                {/* <Button onClick={event => this.closeChangeCustomer(true)} color="primary">{t('SAVE')}</Button> */}
                <Button
                  onClick={(event) => this.closeChangeCustomer(true)}
                  color="primary"
                >
                  {t("SHOW_OFFERINGS")}
                </Button>
              </DialogActions>
            </Dialog>
          )}
          <Loader loading={this.state.loading} />
          <Confirmation
            handleConfirmation={this.removeConfirmation}
            confirmationDialog={this.state.confirmationDialog}
          />
          {this.state.showEditProduct && (
            <ComponentDialog
              open={this.state.showEditProduct}
              mode={"edit"}
              componentType={this.state.componentType}
              editData={this.state.productToEdit}
              closeDialog={this.closeComponentDialog}
              provisioningResources={this.state.provisioningResourceList}
              activationResources={this.state.activationResourceList}
              suspendResources={this.state.suspendResourceList}
              resumeResources={this.state.resumeResourceList}
              categoryList={this.state.productCategoryList}
              addComponentType={
                this.state.showEditProduct.assembly ? "assembly" : "component"
              }
              resetErrorMessage={this.resetErrorMessage}
              channelList={this.state.channelList}
              preQualResourcesList={this.state.preQualResourcesList}
              disableOtherPriceOption={this.disableOtherPriceOption}
              priceOptions={this.state.priceOptions}
            />
          )}
          <div>&nbsp;</div>
          <div>&nbsp;</div>
          <div>&nbsp;</div>
        </main>
      </div>
    );
  }
}

// const styles = {

//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '60vw',
//     },
// };

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    category: state.cart.category,
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    tenantData: state.auth.tenantData,
    permissions: state.auth.userPerms,
    loggedInUserType: state.auth.userLoginType,
    tenantRoles: state.auth.tenantRoles,
    menuPaths: state.auth.menuPaths,
    securityGroupsList: state.auth.securityGroupsList,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    selectCategory: (category) =>
      dispatch({ type: actionTypes.CHANGE_CATEGORY, category }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(PackagedSolutionList)));
